import { BLOCK_TYPES } from '../blocks/types.js';

// About (Phase 3) — the FIRST production content page on the Content Platform, composed exclusively
// from existing blocks. Content is restricted to the verified, already-public brand positioning,
// services and service area: NO fabricated company history, founder, statistics, awards, partners,
// or certifications (Truth-Before-Reach). Presentation data only — no facts/identity restated from
// sabProfile / companyLegalIdentity. The Owner refines this copy here; no React changes required.
export default {
  blocks: [
    { type: BLOCK_TYPES.HERO, title: 'À propos de Black Matte' },
    {
      type: BLOCK_TYPES.INTRO,
      text:
        'Black Matte est un service de chauffeur privé premium à Nantes et en Loire-Atlantique, pour un transport fiable, ponctuel et professionnel — déplacements professionnels comme personnels.',
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Notre approche',
      body: [
        'Chaque trajet est assuré par un chauffeur privé, avec des véhicules haut de gamme et un service personnalisé.',
        'Des tarifs fixes communiqués à l’avance et une prise en charge dans Nantes et sa région.',
      ],
    },
    {
      type: BLOCK_TYPES.FEATURE_GRID,
      heading: 'Pourquoi Black Matte',
      items: [
        { title: 'Ponctualité', text: 'Des chauffeurs à l’heure, pour chaque rendez-vous.' },
        { title: 'Discrétion', text: 'Un service professionnel et confidentiel.' },
        { title: 'Confort', text: 'Des véhicules haut de gamme pour un trajet agréable.' },
        { title: 'Tarifs fixes', text: 'Le prix annoncé est le prix final, sans surprise.' },
      ],
    },
    {
      type: BLOCK_TYPES.CTA,
      heading: 'Réservez votre chauffeur',
      actions: [
        { label: 'Réserver', to: '/reserver' },
        { label: 'Nos services', to: '/services' },
      ],
    },
  ],
};
